module.exports = __webpack_public_path__ + "static/media/new-multiple-choice-question-pink.a27936be.svg";